import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import JxIconButton from '../../../JxControls/JxButtons/JxIconButton';

/**
 * Pure painter for a single dropped-file row: name, matched strategy key
 * (or 'unsupported'), and a remove button.
 * @param {object} props
 * @param {{id: string, name: string, strategyKey: string|null, status: string}} props.entry
 * @param {(id: string) => void} props.onRemove
 * @returns {JSX.Element}
 */
export default function ImportFileRow({ entry, onRemove }) {
    return (
        <div className={`usd-import-file-row ${entry.status}`}>
            <span>{entry.name}</span>
            <span className="usd-import-file-row-actions">
                {entry.strategyKey ?? 'unsupported'}
                <JxIconButton
                    icon={<DeleteOutlineIcon sx={{ fontSize: 16 }} />}
                    title="Remove"
                    onClick={() => onRemove(entry.id)}
                />
            </span>
        </div>
    );
}
